import { computed, Injectable, signal, Signal } from '@angular/core';

export enum DeviceType {
  Mobile = 'mobile',
  Tablet = 'tablet',
  Desktop = 'desktop',
}

@Injectable({
  providedIn: 'root',
})
export class DeviceService {
  // Signal holding the current window width
  windowWidth = signal<number>(0);

  // Computed signal for device type
  readonly deviceType = computed<DeviceType>(() => {
    const width = this.windowWidth();
    if (width <= 600) {
      return DeviceType.Mobile;
    } else if (width <= 1024) {
      return DeviceType.Tablet;
    } else {
      return DeviceType.Desktop;
    }
  });

  // Convenient boolean signals for each device type
  readonly isMobile = computed(() => this.deviceType() === DeviceType.Mobile);
  readonly isTablet = computed(() => this.deviceType() === DeviceType.Tablet);
  readonly isDesktop = computed(() => this.deviceType() === DeviceType.Desktop);

  // Additional useful signals
  readonly isMobileOrTablet = computed(() => this.isMobile() || this.isTablet());
  readonly width = this.windowWidth.asReadonly();
}
